<div class="content-container table-comp">
  <div class="title">
    <mwp-text-translate text="Members / Dependents" jsonKey="membersDependents" />
  </div>
  <div class="content">
    <mwp-table-formarray [form]="coverageFormGroup" [arrayName]="coverageArrayName" [tableColumns]="membersColumns" [dataSource]="membersData" (emitSlideToggleSelection)="selectedMember($event)" />
  </div>
  @if (showAddDependentButton) {
    <div id="showAddDependent" class="footer d-flex justify-content-end w-100" [ngClass]="tierData && displayRates ? 'pb-0' : ''">
      <button class="mwp-button-save" (click)="openDependentDialog()">
        <mwp-text-translate text="Add Dependent" jsonKey="addDependent" />
      </button>
    </div>
  }
</div>
@if (tierData && displayRates) {
  <div class="content-container table-comp">
    <div class="title">
      <mwp-text-translate text="Tiers" jsonKey="tiers" />
    </div>
    <div class="content">
      <mwp-table [tableColumns]="tierColumns" [dataSource]="tierData"></mwp-table>
    </div>
  </div>
}